export interface IQuery { }

export class AllProjectsPageQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Quest.Strategies.Queries.AllProjectsPageQueryV1, TCh.Domain.Quest'

	WorkspaceId: number
	StrategyId: string

	constructor (workspaceId: number, strategyId: string)
	{
		this.WorkspaceId = workspaceId
		this.StrategyId = strategyId
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Quest.Strategies.Queries.AllProjectsPageQueryV1, TCh.Domain.Quest'
	}

}

export class FinishedProjectsPageQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Quest.Strategies.Queries.FinishedProjectsPageQueryV1, TCh.Domain.Quest'

	WorkspaceId: number
	StrategyId: string

	constructor (workspaceId: number, strategyId: string)
	{
		this.WorkspaceId = workspaceId
		this.StrategyId = strategyId
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Quest.Strategies.Queries.FinishedProjectsPageQueryV1, TCh.Domain.Quest'
	}

}

export class ProjectPhaseDefinitionsPageQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Quest.Strategies.Queries.ProjectPhaseDefinitionsPageQueryV1, TCh.Domain.Quest'

	WorkspaceId: number
	StrategyId: string

	constructor (workspaceId: number, strategyId: string)
	{
		this.WorkspaceId = workspaceId
		this.StrategyId = strategyId
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Quest.Strategies.Queries.ProjectPhaseDefinitionsPageQueryV1, TCh.Domain.Quest'
	}

}

export class ProposedProjectsPageQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Quest.Strategies.Queries.ProposedProjectsPageQueryV1, TCh.Domain.Quest'

	WorkspaceId: number
	StrategyId: string

	constructor (workspaceId: number, strategyId: string)
	{
		this.WorkspaceId = workspaceId
		this.StrategyId = strategyId
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Quest.Strategies.Queries.ProposedProjectsPageQueryV1, TCh.Domain.Quest'
	}

}

export class ScheduledProjectsPageQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Quest.Strategies.Queries.ScheduledProjectsPageQueryV1, TCh.Domain.Quest'

	WorkspaceId: number
	StrategyId: string

	constructor (workspaceId: number, strategyId: string)
	{
		this.WorkspaceId = workspaceId
		this.StrategyId = strategyId
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Quest.Strategies.Queries.ScheduledProjectsPageQueryV1, TCh.Domain.Quest'
	}

}

export class StartedProjectsPageQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Quest.Strategies.Queries.StartedProjectsPageQueryV1, TCh.Domain.Quest'

	WorkspaceId: number
	StrategyId: string

	constructor (workspaceId: number, strategyId: string)
	{
		this.WorkspaceId = workspaceId
		this.StrategyId = strategyId
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Quest.Strategies.Queries.StartedProjectsPageQueryV1, TCh.Domain.Quest'
	}

}

export class StrategyByWorkspaceIdQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Quest.Strategies.Queries.StrategyByWorkspaceIdQueryV1, TCh.Domain.Quest'

	WorkspaceId: number

	constructor (workspaceId: number)
	{
		this.WorkspaceId = workspaceId
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Quest.Strategies.Queries.StrategyByWorkspaceIdQueryV1, TCh.Domain.Quest'
	}

}

export class StrategyFixPageQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Quest.Strategies.Queries.StrategyFixPageQueryV1, TCh.Domain.Quest'

	WorkspaceId: number
	StrategyId: string

	constructor (workspaceId: number, strategyId: string)
	{
		this.WorkspaceId = workspaceId
		this.StrategyId = strategyId
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Quest.Strategies.Queries.StrategyFixPageQueryV1, TCh.Domain.Quest'
	}

}

export class StrategySettingsQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Quest.Strategies.Queries.StrategySettingsQueryV1, TCh.Domain.Quest'

	WorkspaceId: number
	StrategyId: string

	constructor (workspaceId: number, strategyId: string)
	{
		this.WorkspaceId = workspaceId
		this.StrategyId = strategyId
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Quest.Strategies.Queries.StrategySettingsQueryV1, TCh.Domain.Quest'
	}

}

